import { useEffect, useState } from "react";
import _ from "lodash";
import apiAgent from "../api/apiAgent";
import { tMsg } from "./ToastNotifications";

export const ThemeDisplay = ({ value }: { value?: string[] }): JSX.Element => {
  const [selectedValues, setSelectedValues] = useState<any[]>([]);
  const fetchThemes = async () => {
    try {
      const response = await apiAgent.DataType.getAll("themes");
      const themes = response.data;

      const sv =
        value?.map((v: any) =>
          themes?.find((theme: any) => theme.id === _.toNumber(v)),
        ) || [];

      setSelectedValues(sv);
    } catch (err) {
      console.warn(err);
      tMsg.warning("Unable to retrieve themes");
      // navigate("/error"); // TODO: put this back after debugging
    }
  };

  useEffect(() => {
    fetchThemes();
  }, []);

  return (
    <div>
      {selectedValues.length > 0 &&
        selectedValues.map(
          (sv, index) => `${index > 0 ? ", " : ""}${sv?.name}`,
        )}
    </div>
  );
};
